import { render, staticRenderFns } from "./SelectedSectorsView.vue?vue&type=template&id=795fd88a&scoped=true&"
import script from "./SelectedSectorsView.vue?vue&type=script&lang=js&"
export * from "./SelectedSectorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fd88a",
  null
  
)

export default component.exports